import { useEffect } from "react";

import classNames from "classnames/bind";
import Button from "common/blocks/Button";
import useModalContext from "common/providers/modal/useModalContext";
import { HigherOfferContent } from "features/vehicleDetails/components/WidgetsRow/components/PartExchangeWidget";
import usePartExchangeQuestionsContext from "features/vehicleDetails/providers/partExchangeQuestions/usePartExchangeQuestionsContext";
import { PartExchangeQuestionAnswersResponse } from "services/motorpoint/partExchangeQuestions";
import parseLegacyDate from "utils/parseLegacyDate";

import { valuePartExchangeModal } from "..";
import VehicleBadge from "../../components/FinanceCalculator/VehicleBadge";
import TooUnique from "../common/TooUnique";
import Wrapper from "../common/Wrapper";
import styles from "./VehicleValued.module.scss";

const cx = classNames.bind(styles);

const VehicleValued = () => {
    const { useSidebar } = useModalContext();
    const { openSidebar, closeSidebar } = useSidebar();
    const {
        partExQuestionsAnswersResponse,
        partExQuestionsVehicle: vehicleCapData,
        resetAllQuestionsData,
        tooUnique,
        modalContent,
        setGetModalContentData,
    } = usePartExchangeQuestionsContext();

    useEffect(() => {
        setGetModalContentData(true);
    });

    const onValueNewVehicle = () => {
        resetAllQuestionsData();
        openSidebar(valuePartExchangeModal);
    };

    const answersResponse =
        (partExQuestionsAnswersResponse as PartExchangeQuestionAnswersResponse.AnswersResponse) ??
        {};

    const validUntilDate: Date | undefined = answersResponse?.ExpiryDate
        ? parseLegacyDate(answersResponse.ExpiryDate)
        : undefined;

    if (!!tooUnique) {
        return (
            <Wrapper>
                <TooUnique
                    tooUnique={tooUnique}
                    onValueNewVehicle={onValueNewVehicle}
                    closeModal={closeSidebar}
                />
            </Wrapper>
        );
    }

    const higherOfferContent = {
        higherOfferLabel: modalContent?.higherOfferLabelText,
        higherOfferButtonText: modalContent?.higherOfferButtonText,
        higherOfferSidePanel: modalContent?.resolvedHigherOfferSidePanel,
    };

    return (
        <Wrapper>
            <div className={cx("vehicleConditionWrapper")}>
                <VehicleBadge
                    appraisalExpiryDate={validUntilDate}
                    imageUrl={vehicleCapData?.ValuationImageUri ?? ""}
                    info={`${vehicleCapData?.Make} ${vehicleCapData?.Range} ${vehicleCapData?.Trim} ${vehicleCapData?.Colour}`}
                    partExQuestionsAnswersResponse={answersResponse}
                    higherOfferContent={higherOfferContent as HigherOfferContent}
                />
                <Button
                    theme="primary"
                    type="button"
                    fullWidth
                    onClick={() => closeSidebar(true)}
                    ariaLabel="Done"
                >
                    Done
                </Button>
                <Button
                    theme="secondary"
                    type="button"
                    fullWidth
                    onClick={onValueNewVehicle}
                    ariaLabel="Value new vehicle"
                >
                    Value new vehicle
                </Button>
            </div>
        </Wrapper>
    );
};

export default VehicleValued;
